<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-if="curso">{{ curso.NOME }}</dd>
  </div>
</template>

<script>
import CursoService from "../../../../domain/corpore/CursoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "view-c-protocolo-serie-colegio",
  props: {
    label: String,
    value: String
  },
  data() {
    return {
      curso: ""
    };
  },
  asyncComputed: {
    cursos() {
      const cursoService = new CursoService(this.$http);
      return cursoService
        .getCursosColegio()
        .then(result => result.find(curso => this.value == curso.CODCURSO))
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/SerieColegio.vue